/*!

=========================================================
* Light Bootstrap Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  Media,
  ControlLabel,
  FormControl,
  FormGroup,
} from "react-bootstrap";
import Select from "react-select";
import Card from "components/Card/Card.jsx";
import NotificationSystem from "react-notification-system";
import Radio from "components/CustomRadio/CustomRadio.jsx";
import { style } from "../../../variables/Variables";
import Button from "components/CustomButton/CustomButton.jsx";
import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import {
  registration,
  getCountry,
  getCity,
  searchSpeciality,
  getInsuaranceCompanyList,
  getOrganizationDataWithoutPagination,
  getBrachDetailsCountryCodeWise,
  AddLead,
} from "../../../Listfunction";
import axios from "axios";
import { getApiErrorMessage } from "utils/getApiErrorMessage";
import Autocomplete from "react-google-autocomplete";
import {
  getServicePartner,
  getServicePartners,
} from "api/service partner/PartnerApi";

class adduser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      cfpassword: "",
      emailError: null,
      passwordError: null,
      cfpasswordError: null,
      mobilenoError: null,
      process: false,
      nameError: null,
      useraccess: "",
      ccode: "+94",
      name: "",
      mobileno: "",
      gender: "",
      genderErr: null,
      role: "0",
      insuarance_ref: false,
      roleError: null,
      errormessage: "",
      profile_data: "",
      profile_dataError: null,
      processing: true,
      errormessages: [],
      profile: "",
      profileError: null,
      addressline1: "",
      addressline1Error: null,
      addressline2: "",
      city: "0",
      cityError: null,
      postalcode: "",
      postalcodeError: null,
      country: "0",
      countryError: null,
      state: "",
      selectedFile: [],
      country_detail: [],
      city_info: [],
      is_sales_rep: 0,
      showOption: false,
      doctor_speciality: "",
      doctor_specialityError: null,
      qualification: "",
      qualificationError: null,
      registration_id: "",
      registration_idError: null,
      signature_url: "",
      signature_Error: null,
      oldSignatutefile: "",
      signature: "",
      signature_data: "",
      doctorspecialityItems: [],
      specialityList: [],
      insuaranceCompanyList: [],
      consultation_fee: "",
      consultation_rate: "",
      medication_rate: "",
      lab_rate: "",
      consultation_feeError: null,
      doctor_languageError: "",
      doctor_language: [],
      quality: "",
      doctor_preference: "",
      is_show_in_app: "No",
      doctor_prefix: "",
      insuarance_company: "",
      // doc_prefix_err: "",
      insuarance_company_err: "",
      country_code: "",
      branchList: [],
      companyList: [],
      district: "",
      chargeType: null,
      chargeTypeOptions: [
        { value: "paid", label: "Paid" },
        { value: "free", label: "Free" },
      ],
      store: null,
      storeError: null,
      is_Home_Care_Enabled: false,
      department: "",
      sort: null,
      leadTime: "",
      leadTimeBuffer: "",
      latitude: "",
      longitude: "",
      formattedAddress: "",
      input: "",
      addressLocationError: null,
      servicePartners: [],
      servicePartnerId: "",
      servicePartnersLoading: false,
      servicePartnersError: "",
      servicePartnerError: null,
      partner_id: "",
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleFileChangeMultiple = this.handleFileChangeMultiple.bind(this);
    this.handleSignatureFileChange = this.handleSignatureFileChange.bind(this);
  }

  loadServicePartners = (selectedPartnerId = "") => {
    const token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({
      servicePartnersLoading: true,
      servicePartnersError: "",
      country: "1",
      addressline1: "",
      addressline2: "",
      postalcode: "",
      state: "",
      addressline1Error: null,
      countryError: null,
      cityError: null,
    });

    const selectedPartnerRequest = selectedPartnerId
      ? getServicePartner(selectedPartnerId, obj).catch(() => null)
      : Promise.resolve(null);

    Promise.all([
      getServicePartners("", "", 1, 100, obj),
      selectedPartnerRequest,
    ])
      .then(([res, selectedPartnerResponse]) => {
        console.log(res.data, "service partners");
        const pagination = res && res.data ? res.data : {};
        const servicePartners = Array.isArray(pagination.data)
          ? [...pagination.data]
          : [];
        const selectedPartner =
          selectedPartnerResponse && selectedPartnerResponse.data
            ? selectedPartnerResponse.data
            : null;

        if (
          selectedPartner &&
          !servicePartners.some(
            (partner) => String(partner.id) === String(selectedPartner.id),
          )
        ) {
          servicePartners.unshift(selectedPartner);
        }

        this.setState({
          servicePartners,
          servicePartnersLoading: false,
          servicePartnerId: selectedPartnerId
            ? String(selectedPartnerId)
            : this.state.servicePartnerId,
          partner_id: selectedPartnerId
            ? String(selectedPartnerId)
            : this.state.partner_id,
        });
      })
      .catch((error) =>
        this.setState({
          servicePartners: [],
          servicePartnersLoading: false,
          servicePartnersError: getApiErrorMessage(error),
        }),
      );

    getCity(obj, 1).then((res) => {
      this.setState({ city_info: res.data || [] });
    });
  };

  onServicePartnerChange = (event) => {
    const servicePartnerId = event.target.value;
    const selectedPartner = this.state.servicePartners.find(
      (partner) => String(partner.id) === servicePartnerId,
    );
    const mobile = String(
      selectedPartner ? selectedPartner.mobile_number || "" : "",
    ).replace(/\D/g, "");
    const ccode = mobile.startsWith("91") ? "+91" : "+94";
    const mobileno =
      mobile.startsWith("94") || mobile.startsWith("91")
        ? mobile.slice(2)
        : mobile;

    this.setState({
      servicePartnerId,
      partner_id: servicePartnerId,
      ccode,
      mobileno,
      servicePartnerError: null,
      mobilenoError: null,
    });
  };

  isSalesRepresntative = (e) => {
    var checked = e.target.checked;
    this.setState({ is_sales_rep: checked });
  };
  isHomeCare = (e) => {
    var checked = e.target.checked;
    this.setState({ is_Home_Care_Enabled: checked });
  };

  handleInputChange = (e, index) => {
    const { name, value } = e.target;
    // const {value } = e.target.type === 'select' ? e.target.selected : e.target.value;
    // console.log(list[index]['country'])
    const findCountryCode = this.state.country_detail.find(
      (data) => data.id === Number(value),
    );
    const countryCode = findCountryCode.country_code;
    this.setState({ countryCode: countryCode });

    if (value != "0") {
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      getBrachDetailsCountryCodeWise(countryCode, obj).then((res) => {
        let branchList = [];
        if (res.data.length > 0) {
          branchList = res.data.map((branch) => {
            return {
              value: branch.id,
              label: branch.name,
            };
          });
        }
        this.setState({ branchList: branchList });
      });

      var country_id = value;
      getCity(obj, country_id).then((res) => {
        this.setState({ city_info: res.data });
      });
    } else if (value == "0") {
      this.setState({ city_info: [], branchList: [] });
    }
    this.setState({
      [name]: value,
    });
  };

  handleSupplierPlaceSelected = (place) => {
    if (place.geometry && place.geometry.location) {
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();
      this.setState({
        addressline1: place.formatted_address || place.name || "",
        formattedAddress: place.formatted_address || place.name || "",
        latitude: lat,
        longitude: lng,
        addressline1Error: null,
        addressLocationError: null,
      });
    } else {
      this.setState({
        latitude: "",
        longitude: "",
        addressLocationError: (
          <small className="text-danger">
            Please select an address with map coordinates.
          </small>
        ),
      });
    }
  };

  handleOpenGoogleMaps = () => {
    window.open(
      "https://www.google.com/maps",
      "GoogleMaps",
      "width=900,height=700",
    );
  };

  handleSupplierInputLocationChange = (event) => {
    const input = event.target.value;
    const [latitude, longitude] = input.split(",").map((coord) => coord.trim());

    if (input.includes(",")) {
      this.setState({
        input,
        latitude: latitude || "",
        longitude: longitude || "",
        addressLocationError: null,
      });
    } else {
      this.setState({
        input,
        latitude: latitude || "",
        longitude: "",
        addressLocationError: null,
      });
    }
  };

  createLeadForSupplier = async (obj, mobile) => {
    const addressform = [
      {
        address_line1: this.state.addressline1,
        address_line2: this.state.addressline2,
        city:
          this.state.city === "" || this.state.city === "0"
            ? "1"
            : this.state.city,
        state: this.state.state,
        country_id: this.state.country,
        postal_code: this.state.postalcode,
        address_type: "Supplier",
        customaddress: this.state.formattedAddress || this.state.addressline1,
        latitude: this.state.latitude,
        longitude: this.state.longitude,
      },
    ];

    const response = await AddLead(
      this.state.name,
      this.state.email,
      mobile,
      null,
      "3",
      addressform,
      "Auto-created from supplier user",
      "1",
      "",
      "admin",
      "",
      null,
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      [],
      [],
      "0",
      obj,
      this.state.countryCode || "",
      "",
    );

    if (response && response.data && response.data.success === false) {
      throw response;
    }
  };

  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700,
    );

    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    this.setState({
      useraccess: token.role,
    });

    const createdPartnerId =
      this.props.location.state && this.props.location.state.createdPartnerId;
    const requestedRole =
      this.props.location.state && this.props.location.state.role;
    if (createdPartnerId || String(requestedRole) === "21") {
      this.setState({ role: "21" });
      this.loadServicePartners(createdPartnerId);
    }

    getCountry(obj).then((cdata) => {
      const countrydata = cdata.data;
      this.setState({
        country_detail: countrydata,
      });
    });

    this.handleCompanyNameOptionsOnChange();

    searchSpeciality(obj).then((response) => {
      const mdata = response.data;
      var activespeciality = [];
      for (let i = 0; i < mdata.length; i++) {
        if (mdata[i].is_active == 1) {
          activespeciality.push(mdata[i]);
        }
      }

      let pcItems = [];
      activespeciality.map((x, i) => {
        pcItems.push({ value: x.id, label: x.title });
      });

      this.setState({
        doctorspecialityItems: pcItems,
        specialityList: activespeciality,
      });
    });
  }

  async handleFileChangeMultiple(event) {
    let data = [];
    data.push(event.target.files);
    this.setState({ selectedFile: data });
  }

  handleEmailChange(event) {
    this.setState({
      email: event.target.value,
    });
    var re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    re.test(event.target.value) === false
      ? this.setState({
          emailError: (
            <small className="text-danger">
              Email is required and format should be <i>abc@def.com</i>.
            </small>
          ),
        })
      : this.setState({ emailError: null });
  }

  handleCompanyNameOptionsOnChange() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    getInsuaranceCompanyList(obj).then((cdata) => {
      const companyData = cdata.data;
      this.setState({
        insuaranceCompanyList: companyData,
      });
    });

    getOrganizationDataWithoutPagination(obj).then((cdata) => {
      const companyData = cdata.data;
      this.setState({
        companyList: companyData,
      });
    });
  }
  handleLeadTimechnage(event) {
    const leadTimeValue =
      event && event.target ? event.target.value : event ? event.value : "";
    this.setState({ leadTime: leadTimeValue });
  }
  handleLeadTimeBufferChange(event) {
    const leadTimeBuffer =
      event && event.target ? event.target.value : event ? event.value : "";
    this.setState({ leadTimeBuffer: leadTimeBuffer });
  }

  hadlemobilenochange(event) {
    this.setState({
      mobileno: event.target.value,
    });
    var digitRex = /^\d+$/;
    digitRex.test(event.target.value) === false
      ? this.setState({
          mobilenoError: (
            <small className="text-danger">mobileno has to be a number.</small>
          ),
        })
      : this.setState({ mobilenoError: null });
  }

  handlenamechnage(event) {
    this.setState({ name: event.target.value });
    event.target.value === ""
      ? this.setState({
          nameError: <small className="text-danger">name is required.</small>,
        })
      : this.setState({ type_textError: null });
  }
  handleLeadTimechnage(event) {
    const leadTimeValue =
      event && event.target ? event.target.value : event ? event.value : "";
    this.setState({ leadTime: leadTimeValue });
  }
  handleLeadTimeBufferChange(event) {
    const leadTimeBuffer =
      event && event.target ? event.target.value : event ? event.value : "";
    this.setState({ leadTimeBuffer: leadTimeBuffer });
  }

  handlequalificationchnage(event) {
    this.setState({ qualification: event.target.value });
    event.target.value === ""
      ? this.setState({
          qualificationError: (
            <small className="text-danger">qualification is required.</small>
          ),
        })
      : this.setState({ type_textError: null });
  }

  handleregistration_idchnage(event) {
    this.setState({ registration_id: event.target.value });
    event.target.value === ""
      ? this.setState({
          registration_idError: (
            <small className="text-danger">registration_id is required.</small>
          ),
        })
      : this.setState({ type_textError: null });
  }

  docDescChange(event) {
    var value = event.target.value;
    this.setState({ doc_desc_err: "", doc_desc: value });
  }

  docExpChange(event) {
    var value = event.target.value;
    console.log(value);
    var re = /^[0-9]*$/;
    if (re.test(value) == true && value <= 20) {
      this.setState({ doc_exp_err: "", doc_exp: value });
    }
  }

  handlePasswordChange(event) {
    this.setState({
      password: event.target.value,
    });
    event.target.value.length < 6
      ? this.setState({
          passwordError: (
            <small className="text-danger">
              You must enter a password of at least 6 characters.
            </small>
          ),
        })
      : this.setState({ passwordError: null });
  }

  handleCfPasswordChange(event) {
    this.setState({
      cfpassword: event.target.value,
    });
    event.target.value !== this.state.password
      ? this.setState({
          cfpasswordError: (
            <small className="text-danger">Passwords do not match.</small>
          ),
        })
      : this.setState({ cfpasswordError: null });
  }

  onChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;
    if (name == "country") {
      if (value != 0) {
        var token = JSON.parse(localStorage.getItem("user"));
        const obj = token.token;
        var country_id = value;
        this.addrssselect(0, value);
        getCity(obj, country_id).then((res) => {
          // console.log(res,'city');
          this.setState({ city_info: res.data });
        });
      } else if (value == "0") {
        this.setState({ city_info: [] });
      }

      this.setState({
        [name]: value,
      });
    } else if (name == "doctor_prefix") {
      this.setState({
        // doc_prefix_err: "",
        [name]: value,
      });
    } else if (name == "insuarance_company") {
      this.setState({
        insuarance_company_err: "",
        [name]: value,
      });
    } else {
      this.setState({
        [name]: value,
      });
    }
  };

  onCunsultFeeChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    const re = /^[0-9]*$/;

    if (re.test(value) == true) {
      this.setState({
        [name]: value,
      });
    }
  };
  onCunsultRateChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    const re = /^[0-9]*$/;

    if (re.test(value) == true) {
      this.setState({
        [name]: value,
      });
    }
  };
  onMedicationRateChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    const re = /^[0-9]*$/;

    if (re.test(value) == true) {
      this.setState({
        [name]: value,
      });
    }
  };
  onLabRateChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    const re = /^[0-9]*$/;

    if (re.test(value) == true) {
      this.setState({
        [name]: value,
      });
    }
  };

  handleSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>User</b> - Added Successfully .
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
    setTimeout(() => {
      this.props.history.push("/admin/user");
    }, 2000);
  }

  handleClick(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>something went wrong</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  async onSubmit() {
    this.setState({ errormessages: [] });
    let error = false;
    const role = Number(this.state.role);

    if (this.state.name.length == 0) {
      error = true;
      this.setState({
        nameError: <small className="text-danger">Name is required.</small>,
      });
    } else {
      this.setState({ nameError: null });
    }
    if (
      (role !== 21 || this.state.mobileno.length > 0) &&
      (this.state.mobileno.length < 9 || this.state.mobileno.length > 11)
    ) {
      error = true;
      this.setState({
        mobilenoError: (
          <small className="text-danger">
            Please enter mobile nunber from 9 to 11 digit.
          </small>
        ),
      });
    } else {
      this.setState({ mobilenoError: null });
    }

    if (this.state.email.length == 0) {
      error = true;
      this.setState({
        emailError: <small className="text-danger">Email is required.</small>,
      });
    } else {
      this.setState({ emailError: null });
    }
    if (role !== 8 && this.state.password.length == 0) {
      error = true;
      this.setState({
        passwordError: (
          <small className="text-danger">Password is required.</small>
        ),
      });
    } else {
      this.setState({ passwordError: null });
    }
    if (role !== 8 && this.state.cfpassword.length == 0) {
      error = true;
      this.setState({
        cfpasswordError: (
          <small className="text-danger">Confirm Password is required.</small>
        ),
      });
    } else {
      this.setState({ cfpasswordError: null });
    }
    if (this.state.role == 0) {
      error = true;
      this.setState({
        roleError: <small className="text-danger">Role is required.</small>,
      });
    } else {
      this.setState({ roleError: null });
    }
    if (role === 8) {
      if (this.state.addressline1.length == 0) {
        error = true;
        this.setState({
          addressline1Error: (
            <small className="text-danger">Supplier address is required.</small>
          ),
        });
      } else {
        this.setState({ addressline1Error: null });
      }

      if (this.state.country == "0") {
        error = true;
        this.setState({
          countryError: (
            <small className="text-danger">Country is required.</small>
          ),
        });
      } else {
        this.setState({ countryError: null });
      }

      if (this.state.city == "0") {
        error = true;
        this.setState({
          cityError: <small className="text-danger">City is required.</small>,
        });
      } else {
        this.setState({ cityError: null });
      }

      if (!this.state.latitude || !this.state.longitude) {
        error = true;
        this.setState({
          addressLocationError: (
            <small className="text-danger">
              Select an address or enter latitude and longitude.
            </small>
          ),
        });
      } else {
        this.setState({ addressLocationError: null });
      }
    }
    if (
      this.state.role == "17" ||
      this.state.role == "18" ||
      this.state.role == "5" ||
      this.state.role == "7" ||
      this.state.role == "13" ||
      this.state.role == "6" ||
      this.state.role == "11" ||
      this.state.role == "2" ||
      this.state.role == "3" ||
      this.state.role == "20"
    ) {
      if (this.state.store === null) {
        error = true;
        this.setState({
          storeError: <small className="text-danger">store is required.</small>,
        });
      } else {
        this.setState({ storeError: null });
      }
    }

    if (this.state.role == 9) {
      if (
        this.state.doctor_speciality == "" ||
        this.state.doctor_speciality == null
      ) {
        error = true;
        this.setState({
          doctor_specialityError: (
            <small className="text-danger">
              Doctor Speciality is required.
            </small>
          ),
        });
      } else {
        this.setState({ doctor_specialityError: null });
      }
    } else {
      this.setState({ doctor_speciality: "" });
    }

    if (this.state.role == 9) {
      if (this.state.doc_desc == "") {
        error = true;
        this.setState({
          doc_desc_err: (
            <small className="text-danger">
              Doctor description is required.
            </small>
          ),
        });
      } else {
        this.setState({ doc_desc_err: null });
      }
    }

    if (this.state.role == 9) {
      if (this.state.gender == "") {
        console.log("text");
        error = true;
        this.setState({
          genderErr: <small className="text-danger">Gender is required.</small>,
        });
      } else {
        this.setState({ genderErr: null });
      }
    }

    if (this.state.role == 9) {
      if (this.state.doctor_language == "") {
        error = true;
        this.setState({
          doctor_languageError: (
            <small className="text-danger">Language is required.</small>
          ),
        });
      } else {
        this.setState({ doctor_languageError: null });
      }
    }

    if (this.state.role == 9) {
      if (this.state.qualification == "") {
        error = true;
        this.setState({
          qualificationError: (
            <small className="text-danger">Qualification is required.</small>
          ),
        });
      } else {
        this.setState({ qualificationError: null });
      }
    }

    if (this.state.role == 9) {
      if (this.state.registration_id == "") {
        error = true;
        this.setState({
          registration_idError: (
            <small className="text-danger">Registration is required.</small>
          ),
        });
      } else {
        this.setState({ registration_idError: null });
      }
    }

    if (this.state.role == 9) {
      if (!this.state.signature) {
        error = true;
        this.setState({
          signature_Error: (
            <small className="text-danger">Signature is required.</small>
          ),
        });
      } else {
        this.setState({ signature_Error: null });
      }
    }

    if (this.state.role == 9) {
      if (this.state.consultation_fee == "") {
        error = true;
        this.setState({
          consultation_feeError: (
            <small className="text-danger">Consultation Fee is required.</small>
          ),
        });
      } else {
        this.setState({ consultation_feeError: null });
      }
    }

    if (this.state.role == 9) {
      if (!this.state.profile) {
        error = true;
        this.setState({
          profileError: (
            <small className="text-danger">Profile Picture is required.</small>
          ),
        });
      } else {
        this.setState({ profileError: null });
      }
    }

    if (this.state.role == 9) {
      if (this.state.doc_exp == "") {
        error = true;
        this.setState({
          doc_exp_err: (
            <small className="text-danger">
              Doctor experience is required.
            </small>
          ),
        });
      } else {
        this.setState({ doc_exp_err: null });
      }
    }
    // if (this.state.role == 9) {
    //   if (this.state.doctor_prefix == "") {
    //     error = true;
    //     this.setState({
    //       doc_prefix_err: (
    //         <small className="text-danger">Please select doctor prefix</small>
    //       ),
    //     });
    //   } else {
    //     this.setState({ doc_prefix_err: null });
    //   }
    // }
    if (this.state.role == 15) {
      if (this.state.insuarance_company == "") {
        error = true;
        this.setState({
          insuarance_company_err: (
            <small className="text-danger">Please select Company</small>
          ),
        });
      } else {
        this.setState({ insuarance_company_err: null });
      }
    }

    if (!error) {
      var mobile =
        role === 21 && !this.state.mobileno
          ? ""
          : this.state.ccode + this.state.mobileno;

      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      if (this.state.profile.length != 0) {
        this.setState({ processing: true });

        const fdata = new FormData();
        fdata.append("profile_pic", this.state.profile);

        let url =
          process.env.REACT_APP_NOT_SECRET_CODE + "/users/upload/profilepic";
        await axios
          .post(url, fdata, {
            headers: {
              Authorization: "Bearer " + obj,
              "X-Country-Code": "BD",
              "X-Client-Name": "WEBSITE",
              "X-Client-Version": "123",
              "Content-Type": "application/json",
              "X-Request-Id": "124",
            },
          })
          .then((res) => {
            var data = res.data.data.profile_picture_url;
            this.setState({ profile_data: data });
          });
      }

      if (this.state.signature.length != 0) {
        this.setState({ processing: true });

        const fdata = new FormData();
        fdata.append("signature_file", this.state.signature);
        let url =
          process.env.REACT_APP_NOT_SECRET_CODE + "/users/upload/signature";
        await axios
          .post(url, fdata, {
            headers: {
              Authorization: "Bearer " + obj,
              "X-Country-Code": "BD",
              "X-Client-Name": "WEBSITE",
              "X-Client-Version": "123",
              "Content-Type": "application/json",
              "X-Request-Id": "124",
            },
          })
          .then((res) => {
            this.setState({ signature_data: res.data.data.signature_file_url });
          });
      } else {
        this.setState({ signature_data: this.state.oldSignatutefile });
      }

      var priscription_data = "";
      // console.log(this.state.selectedFile,'selected file ');
      if (this.state.selectedFile.length != 0) {
        this.setState({ processing: true });

        const fdata = new FormData();

        this.state.selectedFile.map((file) => {
          for (var i = 0; i < file.length; i++) {
            fdata.append("proof_files[]", file[i]);
            console.log(file[i], "in file");
          }
        });

        let url = process.env.REACT_APP_NOT_SECRET_CODE + "/users/upload/proof";
        await axios
          .post(url, fdata, {
            headers: {
              Authorization: "Bearer " + obj,
              "X-Country-Code": "BD",
              "X-Client-Name": "WEBSITE",
              "X-Client-Version": "123",
              "Content-Type": "application/json",
              "X-Request-Id": "124",
            },
          })
          .then((res) => {
            priscription_data = res.data.data.proof_url;

            // priscription_array_data.push(priscription_data);
          });
      }

      var doc_speciality = [this.state.doctor_speciality.value];

      if (this.state.doctor_language.length > 0) {
        var doc_languages = [];
        this.state.doctor_language.map((lan, idx) => {
          doc_languages.push(lan.value);
        });
        doc_languages = doc_languages.join(",");
      }

      var isShowApp = "";
      if (this.state.role == 9) {
        if (this.state.is_show_in_app == "Yes") {
          isShowApp = 1;
        } else if (this.state.is_show_in_app == "No") {
          isShowApp = 0;
        }
      }

      var doctorPrefix = "";
      if (this.state.role == 9) {
        doctorPrefix = this.state.doctor_prefix;
      }
      this.setState({ processing: false }, () => {
        const autoPassword =
          role === 8 ? `${this.state.name}@123` : this.state.password;
        const autoCfPassword =
          role === 8 ? `${this.state.name}@123` : this.state.cfpassword;
        registration(
          this.state.name,
          mobile,
          this.state.email,
          autoPassword,
          autoCfPassword,
          this.state.role,
          doc_speciality,
          this.state.profile_data,
          priscription_data,
          this.state.addressline1,
          this.state.addressline2,
          this.state.city,
          this.state.postalcode,
          this.state.state,
          this.state.country,
          this.state.is_sales_rep,
          this.state.gender,
          this.state.qualification,
          this.state.registration_id,
          this.state.signature_data,
          this.state.consultation_fee,
          this.state.consultation_rate,
          this.state.lab_rate,
          this.state.medication_rate,
          doc_languages,
          this.state.quality,
          isShowApp,
          doctorPrefix,
          this.state.doctor_preference,
          this.state.insuarance_company,
          this.state.district,
          this.state.countryCode,
          !!this.state.chargeType ? this.state.chargeType.value : null,
          !!this.state.store ? this.state.store.value : null,
          this.state.is_Home_Care_Enabled,
          this.state.department,
          this.state.sort,
          this.state.leadTime,
          this.state.leadTimeBuffer,
          this.state.partner_id,
        )
          .then(async (res) => {
            if (res.data.success === false) {
              this.setState({ processing: true });

              const message = res.data.data;
              if (res.data.data.length != 0) {
                var ermessage = [];
                for (var key of Object.keys(res.data.data)) {
                  var data = res.data.data[key];
                  ermessage.push(data);
                }
                this.setState({ errormessages: ermessage });
              } else {
                this.handleClick("bl");
              }
            } else if (res.data.success === true) {
              if (role === 8) {
                try {
                  await this.createLeadForSupplier(obj, mobile);
                } catch (error) {
                  this.setState({
                    processing: true,
                    errormessages: [
                      "Supplier created successfully, but lead creation failed.",
                      getApiErrorMessage(error),
                    ],
                  });
                  this.handleNetworkError("bl", error);
                  return;
                }
              }
              this.handleSuccess("bl");
              this.setState({
                name: "",
                mobileno: "",
                email: "",
                role: "0",
                password: "",
                cfpassword: "",
                profile_data: "",
                profile: "",
                signature: "",
                signature_data: "",
                addressline1: "",
                addressline2: "",
                city: "0",
                postalcode: "",
                country: "0",
                state: "",
                latitude: "",
                longitude: "",
                formattedAddress: "",
                input: "",
              });
            }
            // this.props.history.push('/user');
          })
          .catch((error) => {
            console.log(error, "== error");
            this.handleNetworkError("bl", error);
          });
      });
    }
  }
  handleNetworkError(position, error) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: <div>{getApiErrorMessage(error)}</div>,
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  handleFileChange(event) {
    this.setState({ profile: event.target.files[0] });
  }

  upload() {
    document.getElementById("selectImage").click();
  }
  upload2() {
    document.getElementById("selectImage2").click();
  }
  handleSignatureFileChange(event) {
    this.setState({ signature: event.target.files[0] });
  }

  uploadSignature() {
    document.getElementById("selectSignature").click();
  }

  onSpecialityChange(value) {
    this.setState({ doctor_speciality: value });
    if (value == "" || value == null) {
      this.setState({
        doctor_specialityError: (
          <small className="text-danger">Doctor Speciality is required.</small>
        ),
      });
    } else {
      var speList = this.state.specialityList;
      for (let i = 0; i < speList.length; i++) {
        if (speList[i].id == value.value) {
          this.setState({
            doctor_specialityError: null,
            consultation_fee: speList[i].consultation_fee,
          });
        }
      }
    }
  }
  onChargeTypeChange = (value) => {
    this.setState({ chargeType: value });
  };
  handleSelectChange = (selectedOption) => {
    this.setState({
      insuarance_company: selectedOption ? selectedOption.value : "",
      insuarance_company_err: "",
    });
  };

  render() {
    const leadTimeOptions = Array.from({ length: 31 }, (_, index) => ({
      value: index + 1,
      label: `${index + 1} Days`,
    }));
    const leadTimeBufferOptions = Array.from({ length: 10 }, (_, index) => ({
      value: index + 1,
      label: `${index + 1} Days`,
    }));
    const companyTagData = this.state.insuarance_ref
      ? this.state.insuaranceCompanyList
      : this.state.companyList;
    const insuranceOptions = companyTagData
      ? companyTagData &&
        companyTagData.map((item) => ({
          value: item.id,
          label: item.company_name,
        }))
      : [];
    const errormessage = this.state.errormessage;
    const errormessages = this.state.errormessages;
    return (
      <div className="main-content">
        <Grid fluid>
          <NotificationSystem ref="notificationSystem" style={style} />

          <Row>
            <Col md={6}>
              <Card
                content={
                  <form>
                    {/* {errormessages.length != 0 && (
                      <div className=" alert alert-danger">
                        {errormessages.map((data) => (
                          <React.Fragment>
                            <li>{data}</li>
                          </React.Fragment>
                        ))}
                      </div>
                    )} */}

                    <Row>
                      <Col md={12}>
                        {Number(this.state.role) !== 21 && (
                          <div className="order_source_data">
                            <FormGroup
                              className=""
                              style={{ display: "flex", gap: "10px" }}
                            >
                              <Checkbox
                                number="49"
                                checked={this.state.is_sales_rep}
                                onChange={(e) => this.isSalesRepresntative(e)}
                                label="Is Sales Rep ?"
                              ></Checkbox>
                              {this.state.role == "6" && (
                                <span style={{ marginTop: "0px" }}>
                                  <Checkbox
                                    number="50"
                                    checked={this.state.is_Home_Care_Enabled}
                                    onChange={(e) => this.isHomeCare(e)}
                                    label="Is Home Care ?"
                                  ></Checkbox>
                                </span>
                              )}
                            </FormGroup>
                          </div>
                        )}
                        <FormGroup>
                          <ControlLabel className="roleLabel">
                            Role
                          </ControlLabel>
                          <select
                            name="role"
                            value={this.state.role}
                            onChange={(event) => {
                              if (event.target.value == 9) {
                                this.setState({ showOption: true });
                                this.setState({ insuarance_company: "" });
                                this.setState({ insuarance_ref: false });
                              } else if (event.target.value == 15) {
                                this.setState({ insuarance_ref: true });
                                this.setState({ insuarance_company: "" });
                                this.setState({ doctor_speciality: "" });
                                this.setState({ showOption: false });
                              } else {
                                this.setState({ doctor_speciality: "" });
                                this.setState({ insuarance_company: "" });
                                this.setState({ showOption: false });
                                this.setState({ insuarance_ref: false });
                              }
                              this.setState({ role: event.target.value });
                              if (event.target.value === "21") {
                                this.loadServicePartners();
                              }
                              event.target.value === "0"
                                ? this.setState({
                                    roleError: (
                                      <small className="text-danger">
                                        Role is required.
                                      </small>
                                    ),
                                  })
                                : this.setState({ roleError: null });
                            }}
                            className="form-control"
                          >
                            {this.state.useraccess == 1 && (
                              <React.Fragment>
                                <option value="0">Select Role</option>
                                <option value="1">Super Admin</option>
                                <option value="2">Admin</option>
                                <option value="3">User</option>
                                <option value="4">Third Party</option>
                                <option value="5">Rider</option>
                                <option value="6">Lab Partner</option>
                                <option value="7">Lab Rider</option>
                                <option value="8">Supplier</option>
                                <option value="9">Doctor</option>
                                <option value="10">Courier Partner</option>
                                <option value="11">Pharmacist</option>
                                <option value="12">Partner</option>
                                <option value="13">Procurement</option>
                                <option value="14">Insurance</option>
                                <option value="15">Insurance Ref</option>
                                <option value="16">Reviewer</option>
                                <option value="17">Store Manager</option>
                                <option value="18">Store Pharmacist</option>
                                <option value="19">Customer Service</option>
                                <option value="20">Pharmacy POS User</option>
                                <option value="21">Fulfillment Partner</option>
                              </React.Fragment>
                            )}
                            {this.state.useraccess == 2 && (
                              <React.Fragment>
                                <option value="0">Select Role</option>
                                <option value="3">User</option>
                                <option value="5">Rider</option>
                                <option value="6">Lab Partner</option>
                                <option value="7">Lab Rider</option>
                                <option value="8">Supplier</option>
                                <option value="9">Doctor</option>
                                <option value="10">Courier Partner</option>
                                <option value="11">Pharmacist</option>
                                <option value="12">Partner</option>
                                <option value="13">Procurement</option>
                                <option value="14">Insurance</option>
                                <option value="15">Insurance Ref</option>
                                <option value="16">Reviewer</option>
                                <option value="17">Store Manager</option>
                                <option value="18">Store Pharmacist</option>
                                <option value="19">Customer Service</option>
                                <option value="20">Pharmacy POS User</option>
                                <option value="21">Fulfillment Partner</option>
                              </React.Fragment>
                            )}
                            {this.state.useraccess == 13 && (
                              <React.Fragment>
                                <option value="0">Select Role</option>
                                <option value="8">Supplier</option>
                              </React.Fragment>
                            )}
                          </select>
                          {this.state.roleError}
                        </FormGroup>

                        {this.state.role === "21" && (
                          <FormGroup>
                            <ControlLabel>Partner</ControlLabel>
                            <Button
                              bsSize="small"
                              className="pull-right"
                              style={{
                                backgroundColor: "#343a40",
                                borderColor: "#343a40",
                                color: "#ffffff",
                              }}
                              onClick={() =>
                                this.props.history.push(
                                  "/admin/Create-Service-Partner-Branch",
                                  { returnTo: "/admin/add-user" },
                                )
                              }
                            >
                              Create Service Partner
                            </Button>
                            <select
                              className="form-control"
                              value={this.state.servicePartnerId}
                              onChange={this.onServicePartnerChange}
                              disabled={this.state.servicePartnersLoading}
                            >
                              <option value="">
                                {this.state.servicePartnersLoading
                                  ? "Loading partners..."
                                  : "Select Partner"}
                              </option>
                              {this.state.servicePartners.map((partner) => (
                                <option key={partner.id} value={partner.id}>
                                  {partner.partner_name}
                                  {partner.branch_name
                                    ? ` - ${partner.branch_name}`
                                    : ""}
                                </option>
                              ))}
                            </select>
                            {this.state.servicePartnersError && (
                              <small className="text-danger">
                                {this.state.servicePartnersError}
                              </small>
                            )}
                            {this.state.servicePartnerError}
                          </FormGroup>
                        )}

                        {this.state.showOption == true && (
                          <FormGroup>
                            <ControlLabel>Doctor Prefix</ControlLabel>
                            <select
                              onChange={this.onChange}
                              name="doctor_prefix"
                              value={this.state.doctor_prefix}
                              className="form-control"
                              placeholder="Doctor Prefix"
                            >
                              <option value="">Select Doctor Prefix</option>
                              <option value="Dr.">Dr.</option>
                              <option value="Mrs.">Mrs.</option>
                              <option value="Mr.">Mr.</option>
                              <option value="Prof.">Prof.</option>
                            </select>
                            {/* {this.state.doc_prefix_err} */}
                          </FormGroup>
                        )}
                        {(this.state.insuarance_ref == true ||
                          this.state.role === "16") && (
                          <>
                            <FormGroup>
                              <ControlLabel>Company</ControlLabel>
                              <Select
                                name="insuarance_company"
                                options={insuranceOptions}
                                placeholder="Select Company"
                                value={
                                  insuranceOptions.find(
                                    (opt) =>
                                      opt.value ===
                                      this.state.insuarance_company,
                                  ) || null
                                }
                                onChange={this.handleSelectChange}
                              />
                              {this.state.insuarance_company_err}
                            </FormGroup>
                            <FormGroup>
                              <ControlLabel>Department</ControlLabel>
                              <select
                                value={this.state.department}
                                className="form-control"
                                onChange={(event) => {
                                  this.setState({
                                    department: event.target.value,
                                  });
                                }}
                              >
                                <option value="">Select Deparment</option>
                                <option value="hr">HR</option>
                                <option value="accountant">Accountant</option>
                              </select>
                            </FormGroup>
                          </>
                        )}

                        <FormGroup>
                          <ControlLabel>Name</ControlLabel>
                          <FormControl
                            type="text"
                            onChange={(event) => this.handlenamechnage(event)}
                            required
                            name="name"
                            value={this.state.name || ""}
                            placeholder="Your  Name"
                          />
                          {this.state.nameError}
                        </FormGroup>
                        <FormGroup>
                          <ControlLabel>Email</ControlLabel>
                          <FormControl
                            type="email"
                            onChange={(event) => this.handleEmailChange(event)}
                            value={this.state.email || ""}
                            placeholder="Your email Name"
                            autoComplete="off"
                          />
                          {this.state.emailError}
                        </FormGroup>
                        {this.state.role == 8 && (
                          <>
                            <FormGroup>
                              <ControlLabel>Delivery Lead Time</ControlLabel>
                              <Select
                                name="leadTime"
                                options={leadTimeOptions}
                                value={
                                  leadTimeOptions.find(
                                    (option) =>
                                      String(option.value) ===
                                      String(this.state.leadTime),
                                  ) || null
                                }
                                onChange={(option) =>
                                  this.handleLeadTimechnage(option)
                                }
                                placeholder="Select Delivery Lead Time"
                                isClearable
                              />
                            </FormGroup>
                            <FormGroup>
                              <ControlLabel>Buffer Time</ControlLabel>
                              <Select
                                name="leadTimeBuffer"
                                options={leadTimeBufferOptions}
                                value={
                                  leadTimeBufferOptions.find(
                                    (option) =>
                                      String(option.value) ===
                                      String(this.state.leadTimeBuffer),
                                  ) || null
                                }
                                onChange={(option) =>
                                  this.handleLeadTimeBufferChange(option)
                                }
                                placeholder="Select Buffer Time"
                                isClearable
                              />
                            </FormGroup>
                          </>
                        )}
                        {this.state.role == 6 && (
                          <FormGroup>
                            <ControlLabel>Sort Order</ControlLabel>
                            <FormControl
                              type="number"
                              value={this.state.sort || null}
                              onChange={(event) => {
                                this.setState({ sort: event.target.value });
                              }}
                              placeholder="Enter Sort Order"
                              onWheel={(e) => e.target.blur()}
                            />
                          </FormGroup>
                        )}
                        {Number(this.state.role) !== 21 && (
                          <FormGroup>
                            <ControlLabel>Mobile No</ControlLabel>
                            <Col md={12}>
                              <Col
                                md={2}
                                className="no-padding"
                                style={{ marginTop: "4px" }}
                              >
                                <select
                                  onChange={this.onChange}
                                  name="ccode"
                                  value={this.state.ccode}
                                  className="form-control"
                                >
                                  <option value="+94">+94</option>
                                  <option value="+91">+91</option>
                                </select>
                              </Col>
                              <Col md={10}>
                                <FormControl
                                  type="number"
                                  required={Number(this.state.role) !== 21}
                                  name="mobileno"
                                  onWheel={(e) => e.target.blur()}
                                  onChange={(event) => {
                                    this.setState({
                                      mobileno: event.target.value,
                                    });
                                    (Number(this.state.role) !== 21 ||
                                      event.target.value.length > 0) &&
                                    (event.target.value.length < 9 ||
                                      event.target.value.length > 11)
                                      ? this.setState({
                                          mobilenoError: (
                                            <small className="text-danger">
                                              Please enter mobile nunber from 9
                                              to 11 digit.
                                            </small>
                                          ),
                                        })
                                      : this.setState({ mobilenoError: null });
                                  }}
                                  value={this.state.mobileno || ""}
                                  placeholder="Your Mobile Number"
                                  style={{ width: "105%" }}
                                />
                              </Col>
                              {this.state.mobilenoError}
                            </Col>
                          </FormGroup>
                        )}
                        {Number(this.state.role) !== 8 && (
                          <>
                            <FormGroup>
                              <ControlLabel style={{ marginTop: "5px" }}>
                                Password
                              </ControlLabel>
                              <FormControl
                                type="password"
                                placeholder="Enter Password"
                                onChange={(event) =>
                                  this.handlePasswordChange(event)
                                }
                                value={this.state.password}
                                autoComplete="off"
                              />
                              {this.state.passwordError}
                            </FormGroup>
                            <FormGroup>
                              <ControlLabel>Confirm Password</ControlLabel>
                              <FormControl
                                type="password"
                                onChange={(event) =>
                                  this.handleCfPasswordChange(event)
                                }
                                value={this.state.cfpassword}
                                placeholder="Enter Confirm Password"
                                autoComplete="off"
                              />
                              {this.state.cfpasswordError}
                            </FormGroup>
                          </>
                        )}
                        {Number(this.state.role) !== 8 && (
                          <>
                            <FormGroup>
                              <ControlLabel>Gender</ControlLabel>

                              <div className="order_source_data">
                                <Radio
                                  // style={{'display':'inline-block'}}
                                  number="31"
                                  option="male"
                                  name="gender"
                                  onChange={this.onChange}
                                  checked={this.state.gender === "male"}
                                  label="Male"
                                />
                                &nbsp;
                                <Radio
                                  // style={{'display':'inline-block'}}
                                  number="32"
                                  option="female"
                                  name="gender"
                                  onChange={this.onChange}
                                  checked={this.state.gender === "female"}
                                  label="Female"
                                />
                                <Radio
                                  // style={{'display':'inline-block'}}
                                  number="11"
                                  option="other"
                                  name="gender"
                                  onChange={this.onChange}
                                  checked={this.state.gender === "other"}
                                  label="Other"
                                />
                              </div>
                              {this.state.genderErr}
                            </FormGroup>
                          </>
                        )}
                        {Number(this.state.role) !== 21 && (
                          <FormGroup>
                            {Number(this.state.role) === 8 && (
                              <>
                                <ControlLabel>Address Line 1</ControlLabel>
                                <FormControl
                                  name="addressline1"
                                  value={this.state.addressline1}
                                  onChange={(event) => {
                                    this.setState({
                                      addressline1: event.target.value,
                                      latitude: "",
                                      longitude: "",
                                      formattedAddress: "",
                                      input: "",
                                    });
                                  }}
                                  placeholder="Select supplier address"
                                  type="text"
                                />
                                {this.state.addressline1Error && (
                                  <div style={{ marginTop: "4px", marginBottom: "12px" }}>
                                    {this.state.addressline1Error}
                                  </div>
                                )}

                                <ControlLabel>Address Line 2</ControlLabel>
                                <FormControl
                                  name="addressline2"
                                  value={this.state.addressline2}
                                  onChange={this.onChange}
                                  placeholder="Enter Address Line2"
                                  type="text"
                                />

                                <ControlLabel>Postal code</ControlLabel>
                                <FormControl
                                  name="postalcode"
                                  value={this.state.postalcode}
                                  onWheel={(e) => e.target.blur()}
                                  onChange={(event) => {
                                    this.setState({
                                      postalcode: event.target.value,
                                    });
                                  }}
                                  placeholder="Enter Postal Code"
                                  type="number"
                                />

                                <ControlLabel>
                                  Enter the location coordinates
                                </ControlLabel>
                                <div
                                  style={{
                                    display: "flex",
                                    gap: "8px",
                                    marginBottom: "10px",
                                  }}
                                >
                                  <FormControl
                                    name="coordinates"
                                    type="text"
                                    placeholder="Paste latitude,longitude"
                                    value={this.state.input || ""}
                                    onChange={
                                      this.handleSupplierInputLocationChange
                                    }
                                    onPaste={(event) => {
                                      event.persist();
                                      setTimeout(() => {
                                        const pastedValue = event.target.value;
                                        this.handleSupplierInputLocationChange({
                                          target: { value: pastedValue },
                                        });
                                      }, 0);
                                    }}
                                    style={{ flex: 1 }}
                                  />
                                  <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={this.handleOpenGoogleMaps}
                                    style={{
                                      cursor: "pointer",
                                      borderRadius: "4px",
                                      border: "none",
                                      backgroundColor: "#000000ff",
                                      color: "#fff",
                                      padding: "8px 15px",
                                      minHeight: "34px",
                                    }}
                                  >
                                    Get Location
                                  </button>
                                </div>
                                {this.state.addressLocationError && (
                                  <div style={{ marginTop: "-6px", marginBottom: "12px" }}>
                                    {this.state.addressLocationError}
                                  </div>
                                )}
                                <Row>
                                  <Col md={6}>
                                    <ControlLabel>Latitude</ControlLabel>
                                    <FormControl
                                      name="latitude"
                                      value={this.state.latitude || ""}
                                      onChange={(event) => {
                                        this.setState({
                                          latitude: event.target.value,
                                          addressLocationError: null,
                                        });
                                      }}
                                      placeholder="Latitude"
                                      type="text"
                                    />
                                  </Col>
                                  <Col md={6}>
                                    <ControlLabel>Longitude</ControlLabel>
                                    <FormControl
                                      name="longitude"
                                      value={this.state.longitude || ""}
                                      onChange={(event) => {
                                        this.setState({
                                          longitude: event.target.value,
                                          addressLocationError: null,
                                        });
                                      }}
                                      placeholder="Longitude"
                                      type="text"
                                    />
                                  </Col>
                                </Row>
                              </>
                            )}

                            {Number(this.state.role) !== 8 && (
                              <>
                                <ControlLabel>Address Line 1</ControlLabel>
                                <FormControl
                                  name="addressline1"
                                  value={this.state.addressline1}
                                  onChange={(event) => {
                                    this.setState({
                                      addressline1: event.target.value,
                                    });
                                  }}
                                  placeholder="Enter Address Line1"
                                  type="text"
                                />
                                <ControlLabel>Address Line 2</ControlLabel>
                                <FormControl
                                  name="addressline2"
                                  value={this.state.addressline2}
                                  onChange={this.onChange}
                                  placeholder="Enter Address Line2"
                                  type="text"
                                />
                              </>
                            )}

                            {Number(this.state.role) !== 8 && (
                              <>
                                <ControlLabel>Postal code</ControlLabel>
                                <FormControl
                                  name="postalcode"
                                  value={this.state.postalcode}
                                  onWheel={(e) => e.target.blur()}
                                  onChange={(event) => {
                                    this.setState({
                                      postalcode: event.target.value,
                                    });
                                  }}
                                  placeholder="Enter Postal Code"
                                  type="number"
                                />
                              </>
                            )}

                            <ControlLabel>Country</ControlLabel>
                            <select
                              name="country"
                              value={this.state.country}
                              onChange={this.handleInputChange}
                              className="form-control"
                            >
                              <option value="0">Select Country</option>
                              {this.state.country_detail.map((country_data) => (
                                <option value={country_data.id}>
                                  {country_data.country_name}
                                </option>
                              ))}
                            </select>
                            {this.state.countryError}

                            <br></br>

                            <>
                              <ControlLabel>&nbsp;State</ControlLabel>
                              <FormControl
                                name="state"
                                value={this.state.state}
                                onChange={(event) => {
                                  this.setState({ state: event.target.value });
                                }}
                                placeholder="Enter State"
                                type="text"
                              />
                            </>

                            <ControlLabel>City</ControlLabel>
                            <select
                              name="city"
                              value={this.state.city}
                              onChange={this.onChange}
                              className="form-control"
                            >
                              <option value="0">Select District</option>
                              {this.state.city_info.map((city) => (
                                <option value={city.id}>
                                  {city.city_name}
                                </option>
                              ))}
                            </select>
                            {this.state.cityError}
                          </FormGroup>
                        )}
                        {(this.state.role == "17" ||
                          this.state.role == "18" ||
                          this.state.role == "5" ||
                          this.state.role == "7" ||
                          this.state.role == "13" ||
                          this.state.role == "6" ||
                          this.state.role == "11" ||
                          this.state.role == "2" ||
                          this.state.role == "3" ||
                          this.state.role == "20") && (
                          <FormGroup>
                            <ControlLabel>Branch</ControlLabel>
                            {/* <select
                              name="district"
                              value={this.state.district}
                              onChange={this.onChange}
                              className="form-control"
                            >
                              <option value="0">Select Branch</option>
                              {this.state.branchList.map((data) => (
                                <option value={data.name}>{data.name}</option>
                              ))}
                            </select> */}
                            <Select
                              placeholder="Store Branch"
                              name="store_Branch"
                              value={this.state.store}
                              onChange={(value) =>
                                this.setState({
                                  store: value,
                                  storeError: value
                                    ? null
                                    : "Please select a store branch",
                                })
                              }
                              options={this.state.branchList}
                            />
                            {this.state.storeError}
                          </FormGroup>
                        )}
                        {this.state.showOption == true && (
                          <FormGroup>
                            <ControlLabel className="roleLabel">
                              Doctor Speciality{" "}
                            </ControlLabel>
                            <Select
                              placeholder="Doctor Speciality"
                              name="doctor_speciality"
                              closeMenuOnSelect={true}
                              value={this.state.doctor_speciality}
                              onChange={(value) =>
                                this.onSpecialityChange(value)
                              }
                              options={this.state.doctorspecialityItems}
                            />

                            {this.state.doctor_specialityError}
                          </FormGroup>
                        )}

                        {this.state.showOption == true && (
                          <FormGroup>
                            <ControlLabel className="roleLabel">
                              Language{" "}
                            </ControlLabel>
                            <Select
                              className="react-select info"
                              classNamePrefix="react-select"
                              placeholder="Select Language"
                              name="doctor_language"
                              closeMenuOnSelect={false}
                              isMulti
                              value={this.state.doctor_language}
                              onChange={(value) => {
                                this.setState({ doctor_language: value });
                              }}
                              options={[
                                { value: "English", label: "English" },
                                { value: "Sinhala", label: "Sinhala" },
                                { value: "Tamil", label: "Tamil" },
                                { value: "Hindi", label: "Hindi" },
                                { value: "Mandarin", label: "Mandarin" },
                                { value: "Russian", label: "Russian" },
                                { value: "Arabic", label: "Arabic" },
                                { value: "Bengali", label: "Bengali" },
                                { value: "Dhivehi", label: "Dhivehi" },
                                { value: "Swedish", label: "Swedish" },
                                { value: "Spanish ", label: "Spanish" },
                                { value: "French", label: "French" },
                                { value: "Malayalam ", label: "Malayalam " },
                                { value: "Telugu", label: "Telugu" },
                                { value: "Kannada", label: "Kannada" },
                                { value: "Marathi", label: "Marathi" },
                                { value: "Gujarati", label: "Gujarati" },
                                { value: "Punjabi", label: "Punjabi" },
                                { value: "Urdu", label: "Urdu" },
                                { value: "Nepali", label: "Nepali" },
                                { value: "Thai", label: "Thai" },
                                { value: "Vietnamese", label: "Vietnamese" },
                                { value: "Indonesian", label: "Indonesian" },
                                { value: "Turkish", label: "Turkish" },
                                { value: "Italian", label: "Italian" },
                                { value: "Dutch", label: "Dutch" },
                                { value: "Swedish", label: "Swedish" },
                                { value: "Norwegian", label: "Norwegian" },
                                { value: "Danish", label: "Danish" },
                                { value: "Finnish", label: "Finnish" },
                                { value: "Greek", label: "Greek" },
                                { value: "Hebrew", label: "Hebrew" },
                                {
                                  value: "Persian (Farsi)",
                                  label: "Persian (Farsi)",
                                },
                                { value: "Dhivehi", label: "Dhivehi" },
                                { value: "Other", label: "Other" },
                              ]}
                            />

                            {this.state.doctor_languageError}
                          </FormGroup>
                        )}

                        {this.state.showOption == true && (
                          <FormGroup>
                            <ControlLabel>Qualification</ControlLabel>
                            <FormControl
                              type="text"
                              onChange={(event) =>
                                this.handlequalificationchnage(event)
                              }
                              required
                              name="name"
                              value={this.state.qualification || ""}
                              placeholder="Your Qualification"
                            />
                            {this.state.qualificationError}
                          </FormGroup>
                        )}
                        {this.state.showOption == true && (
                          <FormGroup>
                            <ControlLabel>Registration Id</ControlLabel>
                            <FormControl
                              type="text"
                              onChange={(event) =>
                                this.handleregistration_idchnage(event)
                              }
                              required
                              name="name"
                              value={this.state.registration_id || ""}
                              placeholder="Your Registration Id"
                            />
                            {this.state.registration_idError}
                          </FormGroup>
                        )}

                        {/*this.state.role == 9 &&
                          <FormGroup>
                            <ControlLabel>Doctor Description</ControlLabel>
                            <textarea
                              className="text-area-modification"
                              rows={5}                            
                              style={{width:"100%",resize:"none"}}
                              onChange={(event) => this.docDescChange(event)}
                              name="doc_desc"
                              value={this.state.doc_desc || ""}
                              placeholder="Doctor Description"
                            />
                            {this.state.doc_desc_err}
                          </FormGroup>
                      */}

                        {/*this.state.role == 9  &&
                          <FormGroup>
                            <ControlLabel>Doctor Experience(Year)</ControlLabel>
                            <FormControl
                              type="text"                          
                              onChange={(event) => this.docExpChange(event)}
                              required
                              name="doc_exp"
                              value={this.state.doc_exp || ""}
                              placeholder="Doctor Experience"
                            />
                            {this.state.doc_exp_err}
                          </FormGroup>
                    */}

                        {this.state.showOption == true && (
                          <FormGroup>
                            <ControlLabel>Quality</ControlLabel>
                            <select
                              name="quality"
                              value={this.state.quality}
                              onChange={this.onChange}
                              className="form-control"
                            >
                              <option value="">Select Quality</option>
                              <option value="Friendly">Friendly</option>
                              <option value="Kind">Kind</option>
                              <option value="Patience ">Patience </option>
                            </select>
                          </FormGroup>
                        )}

                        {this.state.role == 9 && (
                          <FormGroup>
                            <ControlLabel>Is Consultation Type?</ControlLabel>
                            <div className="order_source_data">
                              <Radio
                                number="187"
                                option="TALK_NOW"
                                name="doctor_preference"
                                onChange={this.onChange}
                                checked={
                                  this.state.doctor_preference === "TALK_NOW"
                                }
                                label="Talk Now"
                              />
                              &nbsp;
                              <Radio
                                number="188"
                                option="TALK_LATER"
                                name="doctor_preference"
                                onChange={this.onChange}
                                checked={
                                  this.state.doctor_preference === "TALK_LATER"
                                }
                                label="Talk Later"
                              />
                              &nbsp;
                              <Radio
                                number="189"
                                option="BOTH"
                                name="doctor_preference"
                                onChange={this.onChange}
                                checked={
                                  this.state.doctor_preference === "BOTH"
                                }
                                label="Both"
                              />
                              &nbsp;
                              <Radio
                                number="190"
                                option="GLOBAL"
                                name="doctor_preference"
                                onChange={this.onChange}
                                checked={
                                  this.state.doctor_preference === "GLOBAL"
                                }
                                label="Global"
                              />
                            </div>
                          </FormGroup>
                        )}

                        {this.state.showOption == true && (
                          <FormGroup>
                            <ControlLabel>Is show in app?</ControlLabel>

                            <div className="order_source_data">
                              <Radio
                                disabled
                                number="87"
                                option="Yes"
                                name="is_show_in_app"
                                onChange={this.onChange}
                                checked={this.state.is_show_in_app === "Yes"}
                                label="Yes"
                              />
                              &nbsp;
                              <Radio
                                disabled
                                number="88"
                                option="No"
                                name="is_show_in_app"
                                onChange={this.onChange}
                                checked={this.state.is_show_in_app === "No"}
                                label="No"
                              />
                            </div>
                          </FormGroup>
                        )}

                        {this.state.showOption == true && (
                          <FormGroup>
                            <ControlLabel>Signature</ControlLabel>
                            <br></br>

                            <input
                              style={{ display: "none" }}
                              id="selectSignature"
                              type="file"
                              className="form-control"
                              name="signature"
                              onChange={this.handleSignatureFileChange}
                            />
                            <Button
                              onClick={this.uploadSignature}
                              style={{ color: "#2B3A41" }}
                            >
                              {" "}
                              <i
                                className={
                                  this.state.signature == ""
                                    ? "fa fa-plus"
                                    : "fa fa-pencil fa-fw"
                                }
                              ></i>{" "}
                              {this.state.signature == ""
                                ? "Choose Signature"
                                : "Change Signature"}
                            </Button>
                            <br />
                            {this.state.signature_Error}
                          </FormGroup>
                        )}

                        {this.state.role == 9 && (
                          <>
                            <FormGroup>
                              <ControlLabel className="roleLabel">
                                Charge Type
                              </ControlLabel>
                              <Select
                                placeholder="Charge Type"
                                name="chargeType"
                                closeMenuOnSelect={true}
                                value={this.state.chargeType}
                                onChange={(value) =>
                                  this.onChargeTypeChange(value)
                                }
                                options={this.state.chargeTypeOptions}
                              />
                            </FormGroup>
                            <FormGroup>
                              <ControlLabel>Consultation Fee</ControlLabel>
                              <FormControl
                                type="text"
                                onChange={(event) =>
                                  this.onCunsultFeeChange(event)
                                }
                                required
                                name="consultation_fee"
                                value={this.state.consultation_fee || ""}
                                placeholder="Enter Consultation Fee"
                              />
                              {this.state.consultation_feeError}
                            </FormGroup>
                            <Row>
                              <Col md={4} sm={4} xs={12}>
                                <FormGroup>
                                  <ControlLabel>Consultation Rate</ControlLabel>
                                  <FormControl
                                    type="text"
                                    onChange={(event) =>
                                      this.onCunsultRateChange(event)
                                    }
                                    required
                                    name="consultation_rate"
                                    value={this.state.consultation_rate || ""}
                                    placeholder="Enter Consultation Rate"
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={4} sm={4} xs={12}>
                                <FormGroup>
                                  <ControlLabel>Lab Rate</ControlLabel>
                                  <FormControl
                                    type="text"
                                    onChange={(event) =>
                                      this.onLabRateChange(event)
                                    }
                                    required
                                    name="lab_rate"
                                    value={this.state.lab_rate || ""}
                                    placeholder="Enter Lab Rate"
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={4} sm={4} xs={12}>
                                <FormGroup>
                                  <ControlLabel>Medication Rate</ControlLabel>
                                  <FormControl
                                    type="text"
                                    onChange={(event) =>
                                      this.onMedicationRateChange(event)
                                    }
                                    required
                                    name="medication_rate"
                                    value={this.state.medication_rate || ""}
                                    placeholder="Enter Medication Rate"
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                          </>
                        )}

                        <FormGroup>
                          <ControlLabel>Profile Photo</ControlLabel>
                          {/* sss */}
                          <br></br>
                          <input
                            style={{ display: "none" }}
                            id="selectImage"
                            type="file"
                            className="form-control"
                            name="profile"
                            onChange={this.handleFileChange}
                          />
                          <Button
                            onClick={this.upload}
                            style={{ color: "#2B3A41" }}
                          >
                            {" "}
                            <i
                              className={
                                this.state.profile == ""
                                  ? "fa fa-plus"
                                  : "fa fa-pencil fa-fw"
                              }
                            ></i>{" "}
                            {this.state.profile == ""
                              ? "Choose image"
                              : "Change image"}
                          </Button>
                          <br />
                          {this.state.profileError}
                        </FormGroup>
                        <FormGroup style={{ display: "none" }}>
                          <ControlLabel>Documents</ControlLabel>
                          <br></br>
                          <input
                            style={{ display: "none" }}
                            id="selectImage2"
                            type="file"
                            className="form-control"
                            name="prescription"
                            multiple
                            onChange={this.handleFileChangeMultiple}
                            placeholder="Enter oPharma Referance"
                          />
                          <Button
                            onClick={this.upload2}
                            style={{ color: "#2B3A41" }}
                          >
                            {" "}
                            <i
                              className={
                                this.state.selectedFile == ""
                                  ? "fa fa-plus"
                                  : "fa fa-pencil fa-fw"
                              }
                            ></i>{" "}
                            {this.state.selectedFile == ""
                              ? "Choose File"
                              : "Change File"}
                          </Button>
                        </FormGroup>
                        {errormessages.length != 0 && (
                          <div style={{ color: "red", marginBottom: "10px" }}>
                            {errormessages.map((data) => (
                              <React.Fragment>{data}</React.Fragment>
                            ))}
                          </div>
                        )}
                        <Button
                          class="btn-color"
                          onClick={this.onSubmit.bind(this)}
                          fill
                        >
                          Submit
                        </Button>
                      </Col>
                    </Row>
                  </form>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default adduser;
